export default __webpack_public_path__ + "static/media/rat@2x.838a0b7a.png";